import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import type { AdminProductionCrewMember } from "@produce/shared";
import InviteBadge from "./InviteBadge";

/**
 * The crew invited to one production: who, in what role, on which days, and
 * whether the invitation email actually reached them.
 */
export default function CrewInviteTable({ crew }: { crew: AdminProductionCrewMember[] }) {
  if (crew.length === 0) {
    return <p className="text-sm text-muted-foreground">No crew invited to this production.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Crew member</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Days</TableHead>
            <TableHead>Invitation</TableHead>
            <TableHead>Account</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {crew.map((member) => (
            <TableRow key={member.email}>
              <TableCell>
                <div className="font-medium">{member.name}</div>
                <div className="text-sm text-muted-foreground">{member.email}</div>
              </TableCell>
              <TableCell className="text-sm">{member.functions.join(", ") || "—"}</TableCell>
              <TableCell className="text-sm">{member.days.length}</TableCell>
              <TableCell>
                <div className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <InviteBadge member={member} />
                    {member.invitation_count > 1 && (
                      <span className="text-xs text-muted-foreground">
                        sent {member.invitation_count}×
                      </span>
                    )}
                  </div>
                  {/* The badge says it failed; this says why, which is the
                      part that decides what support does next. */}
                  {member.email_bounce_reason && (
                    <span className="text-xs text-destructive">{member.email_bounce_reason}</span>
                  )}
                </div>
              </TableCell>
              <TableCell>
                {member.has_account ? (
                  <Badge variant="outline">Linked</Badge>
                ) : (
                  <span className="text-sm text-muted-foreground">No account</span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
